// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__vMic-","modal":"Modal_modal__1FkID","slide-down":"Modal_slide-down__2SgPw"};